<template>
  <main class="home-page">
    <section class="summary-section">
      <div class="section-heading">
        <span class="section-eyebrow">Indicadores</span>
        <h2>Resumen general</h2>
      </div>

    <div class="summary-grid summary-grid--general">
        <div
          v-if="$store.getters.getPermissions.maps"
          class="counter counter--accent"
        >
          <span class="counter-number">{{ mapsCount }}</span>
          <span class="counter-description">Mapas</span>
        </div>

        <div
          v-if="$store.getters.getPermissions.layers"
          class="counter counter--steel"
        >
          <span class="counter-number">{{ categoriesCount }}</span>
          <span class="counter-description">Categorías de capas</span>
        </div>

        <div
          v-if="$store.getters.getPermissions.users"
          class="counter counter--steel"
        >
          <span class="counter-number">{{ groupsCount }}</span>
          <span class="counter-description">Grupos de usuarios</span>
        </div>

        <div
          v-if="$store.getters.getPermissions.geo"
          class="counter counter--steel"
        >
          <span class="counter-number">{{ geoCount }}</span>
          <span class="counter-description">Geoprocesos</span>
        </div>

        <div
          v-if="$store.getters.getPermissions.layers"
          class="counter counter--steel"
        >
          <span class="counter-number">{{ layersCount }}</span>
          <span class="counter-description">Capas</span>
        </div>

        <div
          v-if="$store.getters.getPermissions.users"
          class="counter counter--steel"
        >
          <span class="counter-number">{{ usersCount }}</span>
          <span class="counter-description">Usuarios</span>
        </div>

        <div
          v-if="hasTerrainPermission"
          class="counter counter--steel"
        >
          <span class="counter-number">{{ terrainCampaignsCount }}</span>
          <span class="counter-description">Campañas de terreno</span>
        </div>
      </div>
    </section>

    <section class="summary-section">
      <div class="section-heading">
        <span class="section-eyebrow">Usuario</span>
        <h2>Resumen usuario</h2>
      </div>

      <div class="summary-grid summary-grid--single">
        <div class="counter counter--accent">
          <span class="counter-number">{{ mapsAssignedToUserID.length }}</span>
          <span class="counter-description">Mapas asignados al usuario</span>
        </div>
      </div>
    </section>
  </main>
</template>

<style>

</style>

<script>
import LogItem from '@/components/LogItem.vue'

import {vuex} from '@/components/mixin/vuex.js'
import {restCount} from '@/components/mixin/restCount.js'
import {restVisor} from '@/components/mixin/restVisor.js'

export default{
  name: 'home',
  mixins: [vuex, restCount, restVisor],
  data(){
    return{
      terrainCampaignsCount: 0
    }
  },
  components:{
      LogItem
  },
  computed: {
    hasTerrainPermission() {
      const terrain = this.$store.getters.getPermissions && this.$store.getters.getPermissions.terrain;
      return !!(terrain && (terrain.manage || terrain.respond || terrain.review || terrain.publish));
    },
  },
  props: [],
  methods:{
    getTerrainCampaignsCount: function() {
      var that = this;
      this.$http.get(this.$store.getters.backendurl + 'api/v1/terrain/campaigns', { params: { page: 1, size: 1 } })
      .then(function (response) {
          that.terrainCampaignsCount = (response.data && response.data.total) || 0;
      })
      .catch(function (error) {
          console.log(error)
      });
    },
  },
  updated () {
      console.log(this.$store.getters.getMapSelectedTool)
  },
  created () {
    //Verificar permisos
    this.$store.getters.getPermissions? true:this.$router.push('/inicio')
    this.$store.getters.getPermissions.visor? true:this.$router.push('/pagina-no-encontrada')
  },
  mounted () {
      this.getMapsCount()
      this.getLayersCount()
      this.getGeoCount()
      this.getUsersCount()
      this.getCategoriesCount()
      this.getGroupsCount()

      if(this.hasTerrainPermission) {
        this.getTerrainCampaignsCount()
      }

      this.getMapsAssigned()
  }
  
}
</script>

<style lang="scss" scoped>
.home-page {
  min-height: 100%;
  padding: 34px 40px 56px;

  background: var(--color-white);
  color: var(--color-graphite);
}

.summary-section {
  margin-bottom: 44px;
}

.section-heading {
  margin-bottom: 22px;
}

.section-eyebrow {
  display: block;
  margin-bottom: 6px;

  color: var(--color-steel);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.section-heading h2 {
  margin: 0;

  color: var(--color-navy);
  font-size: 25px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.summary-grid {
  display: grid;
  gap: 18px;
}

/* 3 columnas en escritorio: 3 arriba y 3 abajo */
.summary-grid--general {
  grid-template-columns: repeat(3, minmax(240px, 1fr));
}

/* Card única más controlada */
.summary-grid--single {
  max-width: 420px;
  grid-template-columns: 1fr;
}

.counter {
  min-height: 140px;
  padding: 28px 26px 24px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  background: var(--color-white);

  border: 1px solid var(--color-line);
  border-top: 4px solid var(--color-steel);
  border-radius: 6px;

  box-shadow: 0 6px 18px rgba(14, 42, 64, 0.08);

  transition:
    transform 0.12s ease,
    box-shadow 0.2s ease,
    border-color 0.2s ease;
}

.counter--accent {
  border-top-color: var(--color-orange);
}

.counter--steel {
  border-top-color: var(--color-steel);
}

.counter:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 24px rgba(14, 42, 64, 0.12);
}

.counter-number {
  margin-bottom: 8px;

  color: var(--color-navy);
  font-size: 38px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: -0.03em;
}

.counter-description {
  color: #6B747C;
  font-size: 13.5px;
  font-weight: 500;
  line-height: 1.35;
}

/* Pantallas medianas: 2 columnas */
@media (max-width: 1100px) {
  .summary-grid--general {
    grid-template-columns: repeat(2, minmax(240px, 1fr));
  }
}

/* Celular: 1 columna */
@media (max-width: 768px) {
  .home-page {
    padding: 24px 18px 40px;
  }

  .summary-grid--general {
    grid-template-columns: 1fr;
  }

  .section-heading h2 {
    font-size: 21px;
  }

  .counter {
    min-height: 120px;
    padding: 22px 20px;
  }

  .counter-number {
    font-size: 32px;
  }
}
</style>
